const normalizeMessageType = (type) => {
  return (
    {
      Text: 'texts',
      Email: 'emails',
      Call: 'phone_calls',
      Form: 'web_forms',
    }[String(type || '').trim()] ||
    type ||
    'all'
  );
};

export default normalizeMessageType;
